import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import logo from './white_dove_small.png';
import { Popover, Button, Overlay } from 'react-bootstrap';
import { get } from './util/Utility';
import './styles/Top.css';
import Link from './util/Link';

class ProfileButton extends Component {

  constructor(props) {
    super(props);
    this.state = {
      canGoBack: false
    };
  }

  logout() {
    window.historyObj.push("/");
    window.firebase.auth().signOut();
  }

  nameClick() {
    if (this.props.location !== "/profile") {
      this.setState({canGoBack: true});
      window.historyObj.push("/profile")
    }
  }

  onHide() {
    if (this.state.canGoBack) {
      window.historyObj.goBack();
    }
    else {
      window.historyObj.push("/")
    }
  }

  componentDidMount() {
    this.setState({canGoBack: false});
  }

  render() {
    const profilePopover = (
      <Popover id="popover-positioned-scrolling-bottom" title="Options">
        <center>

          <p className="popoverTextHeader">Login Email</p>
          <p className="popoverText">{this.props.user.email}</p>

          <div style={{height:10}} />
          <Link to={"/account"}><Button bsSize="small">Account Settings</Button></Link>

          <div style={{height:10}} />
          <Button bsSize="small" onClick={this.logout.bind(this)}>Log out</Button>
        </center>
      </Popover>
    );

    return (
      <span>
        <b><button className="ProfileButton" ref="target" onClick={this.nameClick.bind(this)}>{this.props.name}</button></b>
        <Overlay show={this.props.location === "/profile"} onHide={this.onHide.bind(this)} container={this.props.parent} rootClose placement="bottom" target={() => ReactDOM.findDOMNode(this.refs.target)} >
          {profilePopover}
        </Overlay>
      </span>
    );
  }
}

class Top extends Component {

  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      name: "",
    };

    get('leaders/' + this.props.user.uid, this, null, null, false).then(data => {
      this.setState({name: data.name});
    });
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.unlisten = window.historyObj.listen(function(location, action) { // eslint-disable-line no-unused-vars
      this.forceUpdate();
    }.bind(this));
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  componentWillUnmount() {
    this.unlisten();
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  render() {

    //var fontSize = Math.min(25, (this.state.width - 450) / 12);
    //var marginTop = Math.max(15, (1150 - this.state.width) / 23);

    var churchNameStyle = {
      fontSize: 25,
      letterSpacing: 4,
      fontWeight: 400,
      position: 'absolute',
      top: 15,
      left: 10,
      margin: 0
    }

    const location = window.historyObj.location.pathname;
    const name = this.state.name ? <p className="ProfileNameText">Signed in as <ProfileButton name={this.state.name} parent={this} location={location} {...this.props} /></p> : null;

    if (this.state.width > 750) {
      return (
        <div className="Top">
          <h1 style={churchNameStyle}>Calvary Chapel Orlando</h1>
          <center><img className="LogoImg" src={logo} /></center>
          {name}
        </div>
      );
    } else if (this.state.width > 600) {
      return (
        <div className="Top">
          <img className="LogoImg" src={logo} />
          <h1 style={Object.assign(churchNameStyle, {left: 65})}>Calvary Chapel Orlando</h1>
          {name}
        </div>
      );
    } else if (this.state.width > 350) {
      return (
        <div className="Top">
          <img className="LogoImg" src={logo} />
          <h1 style={Object.assign(churchNameStyle, {left: 65})}>CCO</h1>
          {name}
        </div>
      );
    } else {
      return (
        <div className="Top">
          <img className="LogoImg" src={logo} />
          {name}
        </div>
      );
    }


  }
}

export default Top;



/** WEBPACK FOOTER **
 ** ./src/Top.js
 **/